import { AnyAction, Reducer } from "redux";

import { actionTypes } from "./actions";

export interface IHeaderState {
  isSticky: boolean;
  topOffset: number;
  topVisibleOffset: number;
  height: number;
}

const headerReducer: Reducer<IHeaderState> = (
  state: IHeaderState = {
    height: 0,
    isSticky: false,
    topOffset: 0,
    topVisibleOffset: 0,
  },
  action: AnyAction
): IHeaderState => {
  if (action.type === actionTypes.HEADER_STATE_RECEIVED) {
    return { ...state, ...action.payload };
  }

  return state;
};

export default headerReducer;
